import React from "react";
import { getFullName, getAddress } from "../../components/util/helpers";
import { useIntl } from "react-intl";
import { IonLabel, IonItem, IonAvatar, IonBadge } from "@ionic/react";
import { ReactComponent as AvatarImg } from "../../assets/avatar.svg";
import moment from "moment";
import { Img } from "react-image";

var flatten = require("flat");

const VisitItem = (props) => {
  const { item } = props;
  const intl = useIntl();
  const daysFromLastVisit =
    item.last_visit_time &&
    moment(item.date).diff(moment(item.last_visit_time), "days");
  const color = item.overflow_months_number > 0 ? "danger" : "light";

  return (
    <IonItem
      key={item.id}
      detail={true}
      routerLink={`/app/visits/${item.patient.branch}/${item.patient.id}/${item.id}`}
    >
      <IonAvatar slot="start">
        {item.patient.avatar_url ? (
          <Img
            src={[item.patient.avatar_url]}
            unloader={<AvatarImg style={{ borderRadius: "50%" }} />}
          />
        ) : (
          <AvatarImg style={{ borderRadius: "50%" }} />
        )}
      </IonAvatar>

      <IonLabel>
        <h3>{getFullName(item.patient.surename, item.patient.first_name)}</h3>

        <p>{getAddress(flatten(item.patient, { safe: true }))}</p>
        <IonBadge color={color} slot="end">
          {daysFromLastVisit
            ? `${daysFromLastVisit} ${intl.formatMessage({
                id: "app.mobile.months_from_last_visit",
              })}`
            : intl.formatMessage({
                id: "app.mobile.first_visit",
              })}
        </IonBadge>
      </IonLabel>
      {(item.approved || item.verified) && (
        <IonBadge color={item.verified ? "primary" : "success"} slot="end">
          {intl.formatMessage({
            id: item.verified
              ? "app.mobile.table.verified"
              : "app.mobile.table.approved",
          })}
        </IonBadge>
      )}
    </IonItem>
  );
};

export default VisitItem;
